import React, { useState, Fragment } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { Typography, Box, CircularProgress, Avatar } from "@material-ui/core/"
import styles from "./styles"
import CheckIcon from "@material-ui/icons/Check"
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder"
import { disconnectPartner, acceptPartnerRequest } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import cloudinary from "cloudinary-core"
import LoaderButton from "../LoaderButton"
import noOrganizations from "assets/no-organizations-connected.png"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const ConnectedOrganizations = ({ classes }) => {
  const dispatch = useDispatch()
  const org = useSelector(state => state.organization.currentOrg)
  // console.log(org)

  const currentOrgId = org.id
  const [working, setWorking] = useState({
    id: "",
    loading: false
  })
  const [working2, setWorking2] = useState({
    id: "",
    loading: false
  })

  const handleDisconnect = id => {
    setWorking({ id, loading: true })
    dispatch(disconnectPartner(id))
      .then(res => {
        setWorking({ id: "", loading: false })
        dispatch(openSnackBar({ message: "Partner disconnected." }))
      })
      .catch(error => {
        setWorking({ id: "", loading: false })
        dispatch(
          openSnackBar({ message: "Error: Could not disconnect partner." })
        )
      })
  }

  const handleAccept = id => {
    setWorking2({ id, loading: true })
    dispatch(acceptPartnerRequest(id))
      .then(res => {
        setWorking({ id: "", loading: false })
        dispatch(openSnackBar({ message: "Partner request accepted." }))
      })
      .catch(error => {
        setWorking2({ id: "", loading: false })
        dispatch(
          openSnackBar({ message: "Error: Could not accept partner request." })
        )
      })
  }

  const partnerAddres = address => {
    let initialPartnerAddress = ""
    if (address) {
      try {
        initialPartnerAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialPartnerAddress
  }

  const requesterAddress = address => {
    let initialRequesterAddress = ""
    if (address) {
      try {
        initialRequesterAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialRequesterAddress
  }
  return (
    <Box className={classes.organizationsContainer}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        {org && org.partners && org.partners.length === 0 && (
          <Fragment>
            <img src={noOrganizations} className={classes.noConnectedImg} />
            <Typography variant="h2" className={classes.organizationTitle}>
              No Connected Organizations
            </Typography>
          </Fragment>
        )}
      </Box>
      {org.partners && org.partners.length > 0 ? (
        <Typography variant="h2" className={classes.organizationTitle}>
          Connected Organizations
        </Typography>
      ) : null}

      {org.partners ? (
        org.partners.map((org, i) => (
          <Box key={i}>
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="space-between"
              className={classes.organizationContainer}
            >
              <Box
                className={classes.leftOrganizationContainer}
                display="flex"
                alignItems="center"
              >
                <Avatar
                  className={classes.avatarContainer}
                  src={
                    currentOrgId === org.org_id
                      ? org.partner_logo &&
                        cl.url(JSON.parse(org.partner_logo).public_id, {
                          width: 150,
                          crop: "scale"
                        })
                      : org.requester_logo &&
                        cl.url(JSON.parse(org.requester_logo).public_id, {
                          width: 150,
                          crop: "scale"
                        })
                  }
                />
                <Box>
                  <Typography variant="h5" className={classes.name}>
                    {currentOrgId === org.org_id
                      ? org.partner_name
                      : org.requester_name}
                  </Typography>
                  <Typography variant="h6" className={classes.address}>
                    {currentOrgId === org.org_id
                      ? partnerAddres(org.partner_address)
                      : requesterAddress(org.requester_address)}
                  </Typography>
                </Box>
              </Box>

              <Box
                className={classes.rightOrganizationContainer}
                display="flex"
                flexWrap="wrap"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Box display="flex">
                  {org.accepted ? (
                    <Box display="flex" alignItems="center">
                      <CheckIcon />
                      <Typography
                        color="primary"
                        className={classes.connectedRequestedText}
                      >
                        Connected
                      </Typography>
                    </Box>
                  ) : (
                    <Box display="flex" alignItems="center">
                      {currentOrgId === org.org_id ? (
                        <Box display="flex" alignItems="center">
                          <QueryBuilderIcon color="primary" />
                          <Typography
                            className={classes.connectedRequestedText}
                            color="primary"
                          >
                            Requested
                          </Typography>
                        </Box>
                      ) : (
                        <LoaderButton
                          onClick={() => {
                            handleAccept(org.id)
                          }}
                          working={working2.loading && working2.id === org.id}
                          variant="contained"
                          color="primary"
                          classes={{
                            button: classes.acceptButton,
                            buttonProgress: classes.buttonProgress
                          }}
                        >
                          Accept
                        </LoaderButton>
                      )}
                    </Box>
                  )}
                  {org.accepted ? (
                    <LoaderButton
                      onClick={() => {
                        handleDisconnect(org.id)
                      }}
                      working={working.loading && working.id === org.id}
                      variant="text"
                      classes={{
                        button: !working.loading
                          ? classes.disconnectButton
                          : classes.disconnectButtonWorking,
                        buttonProgress: classes.buttonProgress
                      }}
                    >
                      Disconnect
                    </LoaderButton>
                  ) : (
                    <LoaderButton
                      onClick={() => {
                        handleDisconnect(org.id)
                      }}
                      working={working.loading && working.id === org.id}
                      variant="text"
                      classes={{
                        button: !working.loading
                          ? classes.disconnectButton
                          : classes.disconnectButtonWorking,
                        buttonProgress: classes.buttonProgress
                      }}
                    >
                      Decline
                    </LoaderButton>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        ))
      ) : (
        <Box
          style={{
            display: "flex",
            justifyContent: "center"
            // width: "100%",
            // height: "100%"
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
    </Box>
  )
}

export default withStyles(styles)(ConnectedOrganizations)



// WEBPACK FOOTER //
// ./src/components/ConnectedOrganizations/index.jsx